export default __webpack_public_path__ + "static/media/waiting-music.10ba9013.mp3";